var swiper = new Swiper(".home-banner-slider .mySwiper", {
    autoplay: true,
    loop: true,
});

var swiper = new Swiper(".featured-styles-right .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    autoplay: true,
    breakpoints: {
        0: {
            slidesPerView: 1.15,
            spaceBetween: 20,
            pagination: {
          el: ".featured-styles-right .swiper-pagination",
        },
        },
        480: {
            slidesPerView: 3,
            spaceBetween: 20,
            pagination: {
          el: ".featured-styles-right .swiper-pagination",
        },
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        }
    },
});

var swiper = new Swiper(".top-sellers-left .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 40,
    loop: true,
    autoplay: true,
    // autoplay: {
    //     reverseDirection: true,
    // }
    breakpoints: {
        0: {
            slidesPerView: 1.15,
            spaceBetween: 20,
          pagination: {
          el: ".top-sellers-left .swiper-pagination",
        },
        },
        480: {
            slidesPerView: 3,
            spaceBetween: 20,
          pagination: {
          el: ".top-sellers-left .swiper-pagination",
        },
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        }
    },
});


var swiper = new Swiper(".items-collage-inner .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides:false,
    navigation: false,
    loop: false,
    breakpoints: {
        0: {
            slidesPerView: 1.4,
            spaceBetween: 10,
            navigation: true,
            loop: true,
            centeredSlides: true,
            // slideToClickedSlide: true,
        },
        480: {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: false,
            loop: false,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
            navigation: false,
            loop: false,
          centeredSlides:false,
        }
    },
});

 var swiper = new Swiper("#Ga-Slider", {
      pagination: {
        el: ".swiper-pagination",
      },
      slidesPerView:1,
      spaceBetween:10,
      autoplay:{
        delay:1000,
      },
      breakpoints: {
        0: {
          slidesPerView:1.1,
          spaceBetween:10,
        },
        768: {
          slidesPerView:1,
          spaceBetween:10,
        },
        1024: {
          slidesPerView:1,
          spaceBetween:10,
        },
      },
    });

AOS.init();